const ArgumentWrapper = ({ children, className = '', ...props }) => {
  return (
    <div className={`comp-argument-wrapper ${className}`} {...props}>
      {children}
    </div>
  );
};

export default ArgumentWrapper;
